import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Outlet } from 'react-router-dom';
import HeaderV1 from '../../components/Header/HeaderV1';
import FooterV1 from '../../components/FooterV1';

const ContentLoader = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 64px)' }}>
    <CircularProgress />
  </Box>
);

// Header/Footer are mounted once here and stay mounted across route changes.
// Only the Outlet content is Suspense-boundaried, so lazy page loads never
// unmount/remount the header or menus.
const MainLayout = () => {
  return (
    <>
      <HeaderV1 />
      <Suspense fallback={<ContentLoader />}>
        <Outlet />
      </Suspense>
      <FooterV1 />
    </>
  );
};

export default MainLayout;
